import React from 'react';
import useSWR from 'swr';
import { config } from '../../config/environment';
import { FeaturesContext } from './contexts/features-context';

export function FeaturesProvider({ children }: { children: React.ReactNode }) {
  const archiveMode = config.platformMode === 'archive';
  const { data } = useSWR(archiveMode ? null : '/api/features', async url =>
    fetch(url).then(res => res.json()),
  );

  if (archiveMode) {
    return <FeaturesContext.Provider value={null}>{children}</FeaturesContext.Provider>;
  }

  if (!data) {
    return null;
  }

  return <FeaturesContext.Provider value={data || null}>{children}</FeaturesContext.Provider>;
}
